import React, {Component} from 'react';
import {Field, Fields, reduxForm} from 'redux-form'
import ShowContactPerson from "../contact-person/ShowContactPerson";
import JobDate from "./JobDate";
import SubmitButton from '../common/SubmitButton';
import {validate} from './validate.js';
import Wrapper from '../common/form/Wrapper';
import ValidatedInputField from '../common/form/ValidatedInputField';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import MultistepSelectFormAdapter from '../common/MultistepSelectFormAdapter';
import DropDownOptions from '../helpers/DropDownOptions';
import ReactSelect from '../common/ReactSelect';
import RteEditor from "../common/form/RteEditor";
import afterSubmitFail from '../common/form/focusAfterSubmitFail';
import ResetButton from "../common/ResetButton";

class JobsForm extends React.Component {
    constructor(props) {
        super(props);
    }

    showJobPreviewModal() {
        Object.keys(this.props.initialValues).forEach((fieldName) => this.props.touch(fieldName));
        this.props.showJobPreviewModal();
    }

    render() {
        const {
            contactPersons,
            handleModalClick,
            regions,
            categories,
            workingTimes,
            handleSubmit,
            handleReset,
            isUpdate,
            intl
        } = this.props;

        const statusOptions = [
            {value: '1', label: intl.formatMessage(messages.active)},
            {value: '0', label: intl.formatMessage(messages.inactive)},
        ];


        return (
            <form onSubmit={handleSubmit} noValidate={true}>

                <div>
                    <Wrapper label={intl.formatMessage(messages.contactPerson)}>
                        <Field
                            type="select"
                            name="contactPersonId"
                            component={ReactSelect}
                            options={DropDownOptions.getOptions(contactPersons, 'id', 'name')}
                            placeholder={intl.formatMessage(messages.contactPersonSelect)}
                        />
                        <Field
                            type="button"
                            name="showModal"
                            onChage={handleModalClick}
                            component={ShowContactPerson}
                            props={{handleModalClick: handleModalClick}}
                        />
                    </Wrapper>
                    <Wrapper label={intl.formatMessage(messages.comments)}>
                        <label className="custom-control custom-checkbox m-0">
                            <Field
                                type="checkbox"
                                name="isCommentsAllowed"
                                component="input"
                                className="custom-control-input"
                            />
                            <span className="custom-control-indicator"/>
                            <span className="custom-control-description">
                                {intl.formatMessage(messages.allowUsersAskQuestionsJobs)}
                            </span>
                        </label>
                    </Wrapper>
                    <Fields
                        type="datePicker"
                        names={['startTime', 'endTime']}
                        component={JobDate}
                        props={{
                            startTimeLabel: intl.formatMessage(messages.publishedAt),
                            endTimeLabel: intl.formatMessage(messages.endDate),
                        }}
                    />
                    {/*<Wrapper label="Slut dato">
                        <Field
                            type="datePicker"
                            name="endTime"
                            component={JobDate}
                        />
                        <small className="text-muted">(dd-mm-åååå)</small>
                    </Wrapper>*/}
                    <Wrapper
                        label={intl.formatMessage(messages.region)}
                        inputCol="3"
                    >
                        <Field
                            type="select"
                            name="regionId"
                            component={ReactSelect}
                            options={DropDownOptions.getOptions(regions, 'id', 'value')}
                        />
                    </Wrapper>
                    <Field
                        type="select"
                        name="categoryId"
                        component={MultistepSelectFormAdapter}
                        data={categories}
                        maxCount={1}
                    />
                    <Wrapper
                        label={intl.formatMessage(messages.jobWorkingTime)}
                        inputCol="3"
                    >
                        <Field
                            type="select"
                            name="workingTimeId"
                            component={ReactSelect}
                            options={DropDownOptions.getOptions(workingTimes, 'id', 'value')}
                        />
                    </Wrapper>
                    <Wrapper
                        label={intl.formatMessage(messages.status)}
                        inputCol="3"
                    >
                        <Field
                            type="select"
                            name="status"
                            component={ReactSelect}
                            options={statusOptions}
                        />
                        {/*<Field
                            className="form-control clickable"
                            name="status"
                            component="select"
                        >
                            <option value={1}>{intl.formatMessage(messages.active)}</option>
                            <option value={0}>{intl.formatMessage(messages.inactive)}</option>
                        </Field>*/}
                    </Wrapper>
                    <Field
                        className="form-control"
                        name="title"
                        type="text"
                        component={ValidatedInputField}
                        label={intl.formatMessage(messages.heading)}
                    />
                    <Field
                        type="text"
                        name="content"
                        component={RteEditor}
                        placeholder={intl.formatMessage(messages.descriptionPlaceholder)}
                        className="form-control"
                    />
                </div>
                <hr/>
                <div className="form-group row">
                    <div className="col-sm-12">
                        <div className="offset-sm-2">
                            <SubmitButton isUpdate={isUpdate}/>
                            <ResetButton onClick={handleReset}/>
                            <button
                                type="button"
                                className="btn btn-secondary waves-effect waves-light ml-3"
                                onClick={this.showJobPreviewModal.bind(this)}
                            >
                                {intl.formatMessage(messages.browse)}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

JobsForm = reduxForm({
    form: 'job',
    validate,
    enableReinitialize : true,
    keepDirtyOnReinitialize: true,
    onSubmitFail: afterSubmitFail
    // touchOnChange: false
})(JobsForm);

export default injectIntl(JobsForm);


// WEBPACK FOOTER //
// ./web/src/components/jobs/JobsForm.jsx